import { useState, useEffect, useMemo, useCallback } from 'react';
import { notification, Modal } from 'antd';
import { useDropzone } from 'react-dropzone';
import { useNavigate, useParams } from 'react-router';
import Upload from '../../assets/icons/Upload';
import HighlightOff from '../../assets/icons/HighlightOff';
import HighlightOff2 from '../../assets/icons/HighlightOff2';
import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import Button from '../../components/Button/Button';

import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState } from 'draft-js';

import { durationTypes, currencyTypes } from '../../data';

import RightArrow from '../../assets/icons/RightArrow';
import ThumbsUp from '../../assets/icons/ThumbsUp';
import ThumbsDown from '../../assets/icons/ThumbsDown';
import { getLanguages } from '../../services/schoolService';
import * as services from '../../services/learnService';
import Notif from '../../assets/icons/Notif';

import Video from '../../assets/icons/Video';

import Spinner from '../../components/Spinner/Spinner';

import { baseURL } from '../../utils/axios';

const EditCourse = () => {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const tab = urlParams.get('tab');

  const [active, setActive] = useState(
    tab === 'topic' ? 'topic-content' : 'information'
  );
  //const [active, setActive] = useState('topic-content');

  const [uploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [topic] = useState({});

  const [lessons, setLessons] = useState([]);

  const [setEditorState] = useState(EditorState.createEmpty());

  const [classType, setClassType] = useState('group');
  const [durationType, setDurationtype] = useState('Days');
  const [selectedSubjectClass, setSelectedSubjectClass] = useState('');
  const [content, setContent] = useState([]);
  const [currency, setCurrency] = useState({
    id: 1,
    title: 'Nigerian Naira (₦)',
    symbol: '₦',
  });
  const [teacherLed, setTeacherLed] = useState(false);
  const [learningOutcomes, setLearningOutcomes] = useState([]);
  const [dropdowns, setDropdowns] = useState({
    duration: false,
    currency: false,
    language: false,
    subject: false,
  });
  const [details, setDetails] = useState({
    languages: [],
    subjectClasses: [],
  });

  const [videoUrl, setVideoUrl] = useState('');
  const [file, setFile] = useState('');
  const [topicSaved, setTopicSaved] = useState(false);
  const [lessonCount, setLessonCount] = useState(0);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  let { school } = JSON.parse(localStorage.getItem('userData'));

  const { id } = useParams();

  useEffect(() => {
    let { school } = JSON.parse(localStorage.getItem('userData'));
    const getDetails = async () => {
      let res = await getLanguages();
      let resSubjects = await services.getSubjectClasses(school?.id);

      setDetails({
        ...details,
        languages: res.data.languages,
        subjectClasses: resSubjects.data.school.subjectClasses,
      });
    };

    getDetails();
  }, []);

  let token = localStorage.getItem('token');
  let teacher = JSON.parse(localStorage.getItem('userData'));

  const getSingleCourse = async () => {
    setLoading(true);
    const res = await fetch(`${baseURL}/teachers/${teacher.id}/topics/${id}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json; charset=utf-8',
      },
    });
    const data = await res.json();

    if (res.status === 200) {
      setContent(data?.data?.topic);
      setUpdateData({
        ...updateData,
        title: data.data?.topic?.course?.title,
        description: data.data?.topic?.description,
        duration: data?.data?.topic?.course?.duration?.split(' ')[0],
        price: data?.data?.topic?.course?.price,
        subjectClass: data.data?.topic?.subject_class?.id,
        courseId: data.data?.topic?.course?.id,
        published: data.data.topic.published,
      });

      const mappedLearningOutcomes =
        data.data?.topic?.course?.learning_outcomes.map((item, index) => {
          const outcomeKey = `outcome${index}`;
          return { [outcomeKey]: item.description };
        });

      setLearningOutcomes(mappedLearningOutcomes);
    }

    setClassType(data.data?.topic?.course?.group_class ? 'group' : 'one');

    if (res.status === 401) {
      notification['error']({
        message: 'Session expired, please log in again',
      });
      navigate('/login');
    }
    setLoading(false);
  };

  useEffect(() => {
    getSingleCourse();
  }, []);

  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [updateData, setUpdateData] = useState({
    duration: content?.course?.duration?.split(' ')[0],
    price: content?.course?.price,
    title: content?.title,
    description: content?.description,
  });

  const saveUnit = () => {
    setLessons([topic, ...lessons]);
  };

  const resetDropdown = () => {
    setDropdowns({
      duration: false,
      currency: false,
    });
  };

  //close modal
  const handleCancel = () => {
    setConfirmVisible(false);
    setShowPreview(false);
  };

  //upload image on drop
  const onDrop = useCallback(async (acceptedFiles) => {
    setFile(acceptedFiles[0]);
    setVideoUrl(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  }, []);

  const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    height: '100%',
  };

  const focusedStyle = {
    borderColor: '#2196f3',
  };

  const acceptStyle = {
    borderColor: '#00e676',
  };

  const rejectStyle = {
    borderColor: '#ff1744',
  };

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({ onDrop });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  const handleChange = (evt) => {
    const value = evt.target.value;
    const name = evt.target.name;
    setUpdateData({
      ...updateData,
      [name]: value,
    });
  };

  const handleCheckBox = (e) => {
    setTeacherLed(e.target.checked);
  };

  //create lesson
  const updateCourse = async () => {
    let data = {
      subjectClass: selectedSubjectClass.id
        ? selectedSubjectClass.id
        : updateData.subjectClass,
      groupClass: classType === 'group' ? true : false,
      duration: updateData.duration,
      teacherLed,
      price: updateData.price,
      language: selectedLanguage?.id ? selectedLanguage?.id : 1,
      currency: currency.id,
      learningOutcomes: [
        learningOutcomes[0]?.outcome0 ?? '',
        learningOutcomes[1]?.outcome1 ?? '',
        learningOutcomes[2]?.outcome2 ?? '',
        learningOutcomes[3]?.outcome3 ?? '',
      ],
    };
    try {
      setLoading(true);
      let res = await services.updateCourse(
        teacher.id,
        updateData.courseId,
        data
      );

      notification['success']({
        message: res.message,
      });
      setLoading(false);
      getSingleCourse();
    } catch (error) {
      setLoading(false);
      notification['error']({
        message: error.response.data.message,
      });
    } finally {
      getSingleCourse();
    }
  };
  //save topic
  const updateTopic = async () => {
    let { school } = JSON.parse(localStorage.getItem('userData'));

    if (updateData.title === '' || updateData.description === '') {
      notification['error']({
        message: 'Fields cannpt be empty',
      });

      return;
    }

    let data = {
      title: updateData.title,
      description: updateData.description,
    };

    try {
      setLoading(true);
      let res = await services.updateTopic(
        school?.id,
        updateData.courseId,
        id,
        data
      );
      notification['success']({
        message: res.message,
      });

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      notification['error']({
        message: 'An Error Occurred, please try again',
      });
    } finally {
      getSingleCourse();
    }
  };

  return (
    <div className='add-course'>
      <DashboardHeader tutor />
      <div className='add-course__breadcrumbs'>
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
            fill='#161410'
          />
        </svg>
        <p>
          {' '}
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/tutor-dashboard')}
          >
            Home
          </span>{' '}
          | Your Topics |{' '}
          <b style={{ color: '#161410' }}>Create Topic Content</b>
        </p>
        <div className='add-course__badge'>
          <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M7.33398 9.99992H8.66732V11.3333H7.33398V9.99992ZM7.33398 4.66659H8.66732V8.66659H7.33398V4.66659ZM7.99398 1.33325C4.31398 1.33325 1.33398 4.31992 1.33398 7.99992C1.33398 11.6799 4.31398 14.6666 7.99398 14.6666C11.6807 14.6666 14.6673 11.6799 14.6673 7.99992C14.6673 4.31992 11.6807 1.33325 7.99398 1.33325ZM8.00065 13.3333C5.05398 13.3333 2.66732 10.9466 2.66732 7.99992C2.66732 5.05325 5.05398 2.66659 8.00065 2.66659C10.9473 2.66659 13.334 5.05325 13.334 7.99992C13.334 10.9466 10.9473 13.3333 8.00065 13.3333Z'
              fill='#E58D10'
            />
          </svg>
          <p>{updateData?.published ? 'Published' : 'Unpublished'}</p>
        </div>
      </div>
      <div className='add-course__banner'>
        <div className='add-course__banner__content'>
          <h2>{updateData.title ? updateData.title : ' Course title'}</h2>{' '}
          <p>
            Offered by: <span>{school?.name}</span>
          </p>
        </div>
      </div>
      <div className='add-course__body'>
        <main className='add-course__body__left'>
          <div className='add-course__body__tabs-wrapper'>
            <div
              className={`add-course__body__tabs-wrapper__tab + ${
                active === 'information' && 'tab-active'
              }`}
              onClick={() => setActive('information')}
            >
              <HighlightOff />
              <p className='add-course__body__tabs-wrapper__tab-selected '>
                {' '}
                Subject Information
              </p>
            </div>

            <div
              className={`add-course__body__tabs-wrapper__tab + ${
                active === 'topic-content' && 'tab-active'
              }`}
              onClick={() => setActive('topic-content')}
            >
              <HighlightOff2 />
              <p className='add-course__body__tabs-wrapper__tab-options'>
                {' '}
                Topic content
              </p>
            </div>
          </div>
          {active === 'information' && (
            <div className='add-course__body__form'>
              <div className='add-course__body__form__title'>
                <h2>Subject Information</h2>
              </div>

              <form>
                <div className='dropdown-wrapper'>
                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%', marginBottom: '8px' }}
                    onClick={() =>
                      dropdowns.subject
                        ? setDropdowns({ ...dropdowns, subject: false })
                        : setDropdowns({ ...dropdowns, subject: true })
                    }
                  >
                    <label htmlFor='subject'>Class name</label>

                    <input
                      type='text'
                      name='className'
                      disabled
                      id='subject'
                      placeholder='Select the class you want to create topics for?'
                      value={
                        selectedSubjectClass?.title ||
                        content?.subject_class?.title
                      }
                    />
                    <div className='eye-icon'>
                      <RightArrow />
                    </div>
                  </div>
                  {dropdowns.subject && (
                    <div className='dropdown-wrapper__dropdown'>
                      {details?.subjectClasses?.map((el) => (
                        <div
                          className='dropdown-wrapper__dropdown__item'
                          onClick={() => {
                            setSelectedSubjectClass(el);
                            resetDropdown();
                          }}
                        >
                          <p>{el.title}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className='add-course__body__form__note'>
                    <input type='checkbox' onBlur={handleCheckBox} />
                    <p>
                      Check the box if you want students to watch lessons
                      chronologically (i.e teacher led learning)
                    </p>
                  </div>
                </div>

                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%' }}
                >
                  <label htmlFor='subject'>
                    What type of live class is this subject?
                  </label>

                  <div className='flex-to-column'>
                    {' '}
                    <button
                      className='live-class-type'
                      onClick={(e) => {
                        e.preventDefault();
                        setClassType('group');
                      }}
                    >
                      {classType === 'group' ? <ThumbsUp /> : <ThumbsDown />}
                      <p className={classType === 'group' ? 'bold' : 'faint'}>
                        Group Class
                      </p>
                    </button>
                    <button
                      className='live-class-type'
                      onClick={(e) => {
                        e.preventDefault();
                        setClassType('one');
                      }}
                    >
                      {classType === 'one' ? <ThumbsUp /> : <ThumbsDown />}
                      <p className={classType === 'one' ? 'bold' : 'faint'}>
                        One- on- one class
                      </p>
                    </button>
                  </div>
                </div>

                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%' }}
                >
                  <label htmlFor='subject'>Subject duration</label>
                  <div className='select-input'>
                    <div className='dropdown-wrapper'>
                      <div
                        className='select'
                        // onClick={() => {
                        //   dropdowns.duration
                        //     ? setDropdowns({ ...dropdowns, duration: false })
                        //     : setDropdowns({ ...dropdowns, duration: true });
                        // }}
                      >
                        <p>{durationType}</p>
                        <RightArrow />
                      </div>
                      {dropdowns.duration && (
                        <div className='dropdown-wrapper__dropdown'>
                          {durationTypes.map((el, idx) => (
                            <div
                              className='dropdown-wrapper__dropdown__item'
                              key={idx}
                              onClick={() => {
                                setDurationtype(el);
                                resetDropdown();
                              }}
                            >
                              <p>{el}</p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <input
                      type='number'
                      name='duration'
                      id='class'
                      onChange={handleChange}
                      placeholder='Enter number'
                      value={updateData.duration}
                    />
                  </div>
                </div>

                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%' }}
                >
                  <label htmlFor='price'>
                    How much do you want students to pay for this subject?
                  </label>
                  <div className='select-input'>
                    <div className='dropdown-wrapper'>
                      <div
                        className='select'
                        style={{ width: '178px' }}
                        onClick={() => {
                          dropdowns.duration
                            ? setDropdowns({ ...dropdowns, currency: false })
                            : setDropdowns({ ...dropdowns, currency: true });
                        }}
                      >
                        <p>{currency?.title || 'Nigerian Naira (₦)'}</p>
                        <RightArrow />
                      </div>
                      {dropdowns.currency && (
                        <div className='dropdown-wrapper__dropdown'>
                          {currencyTypes.map((el) => (
                            <div
                              className='dropdown-wrapper__dropdown__item'
                              key={el.id}
                              onClick={() => {
                                setCurrency(el);
                                resetDropdown();
                              }}
                            >
                              <p>{el.title}</p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <input
                      type='text'
                      name='price'
                      id='price'
                      placeholder='Enter price'
                      onChange={handleChange}
                      value={updateData.price}
                    />
                  </div>
                </div>

                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%' }}
                >
                  <label htmlFor='subject'>Learning outcome 1</label>

                  <input
                    type='text'
                    name='outcome0'
                    id='outcome0'
                    defaultValue={
                      content?.course?.learning_outcomes[0]?.description || ''
                    }
                    placeholder='Example; Adhering to forming practices for plant growth'
                    onBlur={(e) => {
                      const newItem = { outcome0: e.target.value };
                      const updatedLearningOutcomes = learningOutcomes.map(
                        (item) =>
                          item.hasOwnProperty('outcome0') ? newItem : item
                      );
                      setLearningOutcomes(updatedLearningOutcomes);
                    }}
                  />
                  <div className='eye-icon'></div>
                  <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
                    160 characters
                  </p>
                </div>
                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%' }}
                >
                  <label htmlFor='subject'>Learning outcome 2</label>

                  <input
                    type='text'
                    name='outcome1'
                    id='outcome1'
                    placeholder='Example; Adhering to forming practices for plant growth'
                    defaultValue={
                      content?.course?.learning_outcomes[1]?.description || ''
                    }
                    onBlur={(e) => {
                      const newItem = { outcome1: e.target.value };
                      const updatedLearningOutcomes = learningOutcomes.map(
                        (item) =>
                          item.hasOwnProperty('outcome1') ? newItem : item
                      );
                      setLearningOutcomes(updatedLearningOutcomes);
                    }}
                  />
                  <div className='eye-icon'></div>
                  <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
                    160 characters
                  </p>
                </div>

                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%' }}
                >
                  <label htmlFor='subject'>Learning outcome 3</label>

                  <input
                    type='text'
                    name='outcome2'
                    id='outcome2'
                    placeholder='Example; Adhering to forming practices for plant growth'
                    defaultValue={
                      content?.course?.learning_outcomes[2]?.description || ''
                    }
                    onBlur={(e) => {
                      const newItem = { outcome2: e.target.value };
                      const updatedLearningOutcomes = learningOutcomes.map(
                        (item) =>
                          item.hasOwnProperty('outcome2') ? newItem : item
                      );
                      setLearningOutcomes(updatedLearningOutcomes);
                    }}
                  />
                  <div className='eye-icon'></div>
                  <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
                    160 characters
                  </p>
                </div>

                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%' }}
                >
                  <label htmlFor='subject'>Learning outcome 4</label>

                  <input
                    type='text'
                    name='outcome1'
                    id='outcome1'
                    placeholder='Example; Adhering to forming practices for plant growth'
                    defaultValue={
                      content?.course?.learning_outcomes[3]?.description || ''
                    }
                    onBlur={(e) => {
                      const newItem = { outcome3: e.target.value };
                      const updatedLearningOutcomes = learningOutcomes.map(
                        (item) =>
                          item.hasOwnProperty('outcome3') ? newItem : item
                      );
                      setLearningOutcomes(updatedLearningOutcomes);
                    }}
                  />
                  <div className='eye-icon'></div>
                  <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
                    160 characters
                  </p>
                </div>

                <div
                  className='dropdown-wrapper'
                  style={{ marginBottom: '24px' }}
                >
                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%', marginBottom: '0px' }}
                    onClick={() =>
                      dropdowns.language
                        ? setDropdowns({ ...dropdowns, language: false })
                        : setDropdowns({ ...dropdowns, language: true })
                    }
                  >
                    <label htmlFor='subject'>Language of instruction</label>

                    <input
                      type='text'
                      name='class'
                      id='class'
                      disabled
                      placeholder='Select Language'
                      defaultValue={selectedLanguage?.name}
                      value={'English'}
                    />
                    <div className='eye-icon'>
                      <RightArrow />
                    </div>
                  </div>
                  {dropdowns.language && (
                    <div className='dropdown-wrapper__dropdown'>
                      {details?.languages?.map((el) => (
                        <div
                          className='dropdown-wrapper__dropdown__item'
                          onClick={() => {
                            setSelectedLanguage(el);
                            resetDropdown();
                          }}
                        >
                          <p>{el.name}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%' }}
                >
                  <label htmlFor='teaser'>
                    Upload a video introducing the expectations and learning
                    outcomes for this subject (optional)
                  </label>

                  <div className='dropzone-video'>
                    {uploading ? (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Spinner />
                      </div>
                    ) : videoUrl ? (
                      <>
                        <div className='video-preview'>
                          <video src={videoUrl[0]?.preview}></video>
                          <div className='video-preview__video-details'>
                            <div className='video-preview__video-details__icon'>
                              <Video />
                            </div>
                            <p>{videoUrl[0]?.name}</p>
                          </div>
                        </div>
                        <div
                          className='replace-vid'
                          onClick={() => setVideoUrl('')}
                        >
                          <Upload />
                          <p>Replace Video</p>
                        </div>
                      </>
                    ) : (
                      <div className='container'>
                        <div {...getRootProps({ style })}>
                          <input {...getInputProps()} />
                          <Upload />
                          <p>Drag and drop video or </p>
                          <p className='sec-text'> Upload from your computer</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='notif'>
                  <Notif />
                  <p>All files should be at least 720p and less than 4.0GB</p>
                </div>
              </form>
            </div>
          )}

          {active === 'topic-content' && (
            <div className='add-course__body__form'>
              <div className='add-course__body__form__title'>
                <h2>Topic Content</h2>
                <p>
                  Enter the title and a description for the topic you want to
                  create lesson for
                </p>
              </div>

              <div
                className='auth-wrapper__right__form__inputwrapper eye-position'
                style={{ width: '100%' }}
              >
                <label htmlFor='title'>Topic title</label>

                <input
                  type='text'
                  name='title'
                  id='title'
                  placeholder='Create a new topic'
                  onChange={handleChange}
                  value={updateData.title}
                />
              </div>

              <div
                className='auth-wrapper__right__form__inputwrapper eye-position'
                style={{ width: '100%' }}
              >
                <label htmlFor='description'>Topic description</label>

                <textarea
                  type='text'
                  name='description'
                  id='description'
                  onChange={handleChange}
                  value={updateData.description}
                  placeholder="Example; Linear algebraic equation made easy is the art and science of cultivating the soil, growing crops and raising livestock. It includes the preparation of plant and animal products for people to use and their distribution to markets. Agriculture provides most of the world's food and fabrics. Agriculture is the art and science of cultivating the soil, growing crops and raising livestock. It includes the preparation of plant and animal products"
                />
              </div>
            </div>
          )}
        </main>
      </div>
      <footer className='add-course__footer'>
        <div
          className='add-course__footer__btn-group'
          style={{ cursor: 'pointer' }}
          onClick={() => navigate(-1)}
        >
          <svg
            width='18'
            height='12'
            viewBox='0 0 18 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M18 5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H18V5Z'
              fill='#161410'
            />
          </svg>
          <p>Back</p>
        </div>
        {active === 'topic-content' ? (
          <Button
            text={
              <p style={{ color: '#161410' }}>
                {loading ? 'Please Wait...' : 'Save'}
              </p>
            }
            className='primary-btn'
            onClick={() => updateTopic()}
            disabled={loading}
          />
        ) : (
          <Button
            disabled={loading}
            text={
              <div
                style={{ display: 'flex', gap: '11px', alignItems: 'center' }}
              >
                <p style={{ color: '#161410' }}>
                  {loading ? 'Please wait...' : 'Save'}
                </p>
                <svg
                  width='18'
                  height='13'
                  viewBox='0 0 18 13'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M0 7.03613L14.17 7.03613L10.59 10.6261L12 12.0361L18 6.03613L12 0.0361328L10.59 1.44613L14.17 5.03613L0 5.03613V7.03613Z'
                    fill='#161410'
                  />
                </svg>
              </div>
            }
            className='primary-btn'
            onClick={() => updateCourse()}
          />
        )}
      </footer>

      <Modal
        width={606}
        visible={showPreview}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ padding: '40px' }}>
          <h2>Uploaded teaser</h2>
          <div className='teaser-wrap'>
            <video controls>
              <source src={content?.course?.teaser} type='video/mp4' />
              Your browser does not support HTML video.
            </video>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EditCourse;
